type Callback = (year:string, server:string)=>void;

export default class HashEvent {

    private static _instance: HashEvent;
    private callbackList: Array<(year:string, server:string)=>void> = [];

    public static get instance() {
        return this._instance || (this._instance = new this());
    }

    public init() {
        window.addEventListener('hashchange', e => {
            const list = location.hash.split("#!/")[1];
            const listArr = !!list && list.split('/');

            if (listArr) {
                const year = (!/^\d{4}$/.test(listArr[0]))? '0000':  listArr[0];
                const server = listArr[1] || 'ALL';
                this.callbackList.forEach(_fn => _fn(year, server));
            } else {
                this.callbackList.forEach(_fn => _fn( '0000', 'ALL'));   
            }
        });
    }

    public addCallback(_fn: Callback) {
        this.callbackList.push(_fn);
    }

    public fire(){
        const evt = new Event("hashchange", {"bubbles":true, "cancelable":false});
        document.dispatchEvent(evt);
    }


} // end of class